import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { WeeklyRestBlock } from '../blocks/WeeklyRestBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const WeeklyRestsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { weeklyRests } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {weeklyRests.map((item, index) => (
        <WeeklyRestBlock key={index} weeklyRest={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default WeeklyRestsLayer
